const DARK = "#1c1c1c";
const LIGHT = "#fdf4ee";

function parseColor(value) {
  const probe = document.createElement("span");
  probe.style.color = value;
  document.body.appendChild(probe);
  const match = getComputedStyle(probe).color.match(/[\d.]+/g);
  probe.remove();
  return match ? match.slice(0, 3).map(Number) : null;
}

function luminance(rgb) {
  const channels = rgb.map(value => {
    const channel = value / 255;
    return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
}

function contrastRatio(first, second) {
  const lighter = Math.max(first, second);
  const darker = Math.min(first, second);
  return (lighter + 0.05) / (darker + 0.05);
}

function setContrast(page) {
  const background = getComputedStyle(page).getPropertyValue("--tag-archive-bg").trim();
  const rgb = parseColor(background);
  if (!rgb) return;

  const backgroundLuminance = luminance(rgb);
  const darkContrast = contrastRatio(backgroundLuminance, luminance([28, 28, 28]));
  const lightContrast = contrastRatio(backgroundLuminance, luminance([253, 244, 238]));
  page.style.setProperty("--tag-archive-contrast", darkContrast >= lightContrast ? DARK : LIGHT);
}

export default function initTagArchive(root = document) {
  root.querySelectorAll("[data-tag-archive-color]").forEach(page => {
    if (page.dataset.tagArchiveReady === "true") return;
    page.dataset.tagArchiveReady = "true";
    setContrast(page);
  });
}
